module.exports = __webpack_public_path__ + "static/media/santa-reliquia-virgen-coromoto-altar.f2526732.jpg";